import React from "react";
import { Box, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(6, 3),
    textAlign: "center",
  },
  iconWrapper: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    background:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.06)"
        : "rgba(0,0,0,0.04)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(2),
    fontSize: 36,
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.75),
    color: theme.palette.text.primary,
  },
  description: {
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
    maxWidth: 340,
    lineHeight: 1.6,
    marginBottom: theme.spacing(2.5),
  },
  button: {
    borderRadius: 8,
    fontWeight: 600,
    textTransform: "none",
    padding: theme.spacing(1, 3),
  },
}));

const EmptyState = ({ icon, title, description, actionLabel, onAction }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {icon && <div className={classes.iconWrapper}>{icon}</div>}
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
      {description && (
        <Typography className={classes.description}>{description}</Typography>
      )}
      {actionLabel && onAction && (
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
